/**
 * Notification Preferences Types
 * Defines user preferences for notification behavior
 */

export type ToastPosition = 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';

export type NotificationEventType =
  | 'access_granted'
  | 'access_denied'
  | 'door_events'
  | 'device_alerts'
  | 'system_alerts';

export interface NotificationEventPreferences {
  accessGranted: boolean;     // Face recognized/authorized access
  accessDenied: boolean;       // Unauthorized access attempts
  doorEvents: boolean;         // Door open/close events
  deviceAlerts: boolean;       // Low battery, offline devices
  systemAlerts: boolean;       // Maintenance, updates
}

export interface DoNotDisturbSchedule {
  enabled: boolean;
  startTime: string;           // "22:00" format (24h)
  endTime: string;             // "08:00" format (24h)
}

export interface NotificationPreferences {
  // Global settings
  enabled: boolean;                          // Master on/off switch

  // Notification types
  showToasts: boolean;                       // Show toast popups
  showBrowserNotifications: boolean;         // Browser push notifications
  playSound: boolean;                        // Audio alerts

  // Event-specific preferences
  events: NotificationEventPreferences;

  // Display preferences
  toastDuration: number;                     // Toast display time (milliseconds)
  toastPosition: ToastPosition;              // Toast position on screen

  // Do Not Disturb
  dnd: DoNotDisturbSchedule;
}

export const DEFAULT_NOTIFICATION_PREFERENCES: NotificationPreferences = {
  enabled: true,
  showToasts: true,
  showBrowserNotifications: false,
  playSound: false,
  events: {
    accessGranted: true,
    accessDenied: true,
    doorEvents: true,
    deviceAlerts: true,
    systemAlerts: true,
  },
  toastDuration: 4000,
  toastPosition: 'top-right',
  dnd: {
    enabled: false,
    startTime: '22:00',
    endTime: '08:00',
  },
};
